'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48(evaluator$31) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$48__f_evaluator$11 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$48__f_evaluator$11 = evaluator$31;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$48() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$48__f_evaluator$11.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$48, "app.api.DrugRequestsAcceptedListItem$$anon$48", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$48: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$48 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$48.js.map
